import { TextBox } from "devextreme-react";
import React from "react"
import { CodeTemplates } from "../../../../../Constantes/codeDocumentationTemplates";

function BackOfficeForm(props){
const {classes, onChange, dataForm, templateCode} = props;
    return(
       
        <div id="documentation-request-form">
             {(templateCode === CodeTemplates.FIRST_DRIVER || templateCode === CodeTemplates.SECOND_DRIVER || templateCode === CodeTemplates.TRAVEL_ABROAD) &&
             <>
                <div style={{marginBottom: "1rem"}}>
                   <TextBox label={"Cliente"} labelMode="floating" key={"client"} name="client" value={dataForm?.client} onValueChanged={(e) => onChange("client", e.value)} className={classes.controlers} ></TextBox>
                </div>
                
               <div className="grid-two-columns">
                <TextBox label={"Código postal"} labelMode="floating"  key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} ></TextBox>
                <TextBox label={"Provincia"} labelMode="floating"  key={"province"} name="province" value={dataForm?.province} onValueChanged={(e) => onChange("province", e.value)}  className={classes.controlers} ></TextBox>
                <TextBox label={"Dirección"} labelMode="floating" key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address", e.value)} className={classes.controlers} ></TextBox>
                <TextBox label={"Localidad"} labelMode="floating"  key={"city"} name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city", e.value)} className={classes.controlers} ></TextBox>
               </div>
           </>
            }
           {templateCode === CodeTemplates.RENT && 
            <div className="grid-two-columns">
                <TextBox label={"Cliente"} labelMode="floating"  key={"client"} name="client" value={dataForm?.client} onValueChanged={(e) => onChange("client", e.value)} className={classes.controlers} ></TextBox>
                <TextBox label={"CIF"} labelMode="floating"  key={"cif"} name="cif" value={dataForm?.cif} onValueChanged={(e) => onChange("cif", e.value)} className={classes.controlers} ></TextBox>

       </div> }   
        </div>
    )
}

export {BackOfficeForm}
